import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "search-component" }
const _hoisted_2 = {
  class: "row g-3 mb-3",
  action: "/search"
}
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "search-component-enter-term"
}
const _hoisted_7 = {
  key: 1,
  class: "search-component-no-results"
}
const _hoisted_8 = {
  key: 2,
  class: "search-component-results-found"
}
const _hoisted_9 = {
  key: 3,
  class: "search-component-results"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "search-component-result-item-title" }
const _hoisted_12 = { class: "search-component-result-item-description" }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 4,
  class: "search-component-loading"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 5,
  class: "search-component-buttons"
}
const _hoisted_18 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          name: "q",
          required: "",
          placeholder: "Keyword search",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.inputValue) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $data.inputValue]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          type: "submit",
          disabled: $data.status==='loading'
        }, "Search", 8 /* PROPS */, _hoisted_5)
      ])
    ]),
    (!$data.q)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Please enter a search term. "))
      : _createCommentVNode("v-if", true),
    ($data.q && $data.status==='ready' && $data.results.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No search results found for term '" + _toDisplayString($data.q) + "'. ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($data.results.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($data.resultsCount) + " results found for term '" + _toDisplayString($data.q) + "': ", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($data.results.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.results, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "search-component-result-item",
              value: result.id
            }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(result.name), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_12, _toDisplayString(result.description), 1 /* TEXT */),
              _createElementVNode("a", {
                class: "search-component-result-item-link",
                href: result.url
              }, _toDisplayString(result.url), 9 /* TEXT, PROPS */, _hoisted_13)
            ], 8 /* PROPS */, _hoisted_10))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    ($data.status==='loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : _createCommentVNode("v-if", true),
    ($data.pageNumber < $data.pageCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.nextPage && $options.nextPage(...args))),
            disabled: $data.status==='loading'
          }, "More Results", 8 /* PROPS */, _hoisted_18)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}